module.exports = __webpack_public_path__ + "static/media/c4affba2-2178-420a-9c78-d495d4b418a9.ace39f32.JPG";